import React from "react";
import {
  Box,
  IconButton,
  Divider,
  useTheme,
} from "@mui/material";
import { Close as CloseIcon } from "@mui/icons-material";

import ConversationDetails from "../../../components/ConversationDetails";

const ConversationDetailsPane = ({
  isMobile,
  containerStyle,
  selectedConversation,
  onClose,
  onUpdateConversation,
  aiInsights,
  isLoadingInsights,
  aiInsightsError,
  onLoadAiInsights,
  onRefetchConversationDetails,
}) => {
  const theme = useTheme();

  return (
    <Box
      className="tour-chat-details-pane"
      width={isMobile ? "100%" : "25%"}
      bgcolor={theme.palette.background.paper}
      display="flex"
      flexDirection="column"
      height="100%"
      sx={{
        ...containerStyle,
        minHeight: 0,
      }}
    >
      <Box
        display="flex"
        alignItems="center"
        justifyContent={isMobile ? "space-between" : "flex-end"}
        px={1}
        sx={{
          height: 56,
          position: "sticky",
          top: 0,
          zIndex: 1,
          backgroundColor: theme.palette.background.paper,
          borderBottom: `1px solid ${theme.palette.divider}`,
        }}
      >
        {isMobile && (
          <Box display="flex" alignItems="center" gap={1}>
            <IconButton size="small" onClick={onClose}>
              <CloseIcon />
            </IconButton>
          </Box>
        )}
        {!isMobile && (
          <IconButton onClick={onClose}>
            <CloseIcon />
          </IconButton>
        )}
      </Box>

      <Divider />

      <ConversationDetails
        selectedConversation={selectedConversation}
        onSelectedConversationUpdate={onUpdateConversation}
        full={isMobile}
        aiInsights={aiInsights}
        isLoadingInsights={isLoadingInsights}
        aiInsightsError={aiInsightsError}
        onLoadAiInsights={onLoadAiInsights}
        onRefetchConversationDetails={onRefetchConversationDetails}
      />
    </Box>
  );
};

export default ConversationDetailsPane;
